<script>
  import { itemMixin } from './mixin'
  import NavigationItemArrow from './NavigationItemArrow'
  import NavigationItemBadge from './NavigationItemBadge'
  import NavigationItemIcon from './NavigationItemIcon'

  export default {
    name: 'navigation-collapsed-item',

    components: {
      NavigationItemArrow,
      NavigationItemBadge,
      NavigationItemIcon
    },

    mixins: [itemMixin],

    props: {
      item: {
        type: Object,
        default: null
      }
    },

    watch: {
      item () {
        this.active = this.item && this.item.href ? this.isLinkActive(this.item) : false
        this.childActive = this.item && this.item.children
          ? this.isChildActive(this.item.children)
          : false
      }
    }
  }
</script>

<template>
  <div v-if="item"
       class="menu-item collapsed-item"
       :class="[{'open-item' : item.children}, {'active-item' : active}, {'parent-active-item' : childActive}]">
    <template>
      <router-link class="item-link"
                   :to="item.href ? item.href : ''"
                   :disabled="item.disabled"
                   :event="item.disabled ? '' : 'click'" @click.native="clickEvent($event, true)">
        <navigation-item-icon :item="item"/>
        <navigation-item-badge :item="item"/>
        {{ item.title }}
        <navigation-item-arrow :item="item" :is-open="true"/>
      </router-link>
    </template>
  </div>
</template>
